/* eslint-disable @typescript-eslint/no-explicit-any */
import { IPartnerWebpage, License } from "./lib/models"
import { BusinessClassification } from "./types"

export interface ApiResponse<T = undefined> {
  success: boolean
  message?: string
  data?: T
  traceId?: string
}

export const CRUD_SERVICE_URL =
  process.env.NEXT_PUBLIC_CRUD_SERVICE_URL ?? process.env.CRUD_SERVICE_URL

export async function fetchCrudService(
  method: "GET" | "POST" | "PATCH" | "DELETE",
  body: any = null,
  path: string
): Promise<any> {
  // dev_log(`⏳ [${method}] CS/${path}`, "(body)", body)
  let headers: any = {}
  if (["POST", "PATCH"].includes(method)) {
    headers = {
      ...headers,
      "Content-Type": "application/json",
    }
  }

  const baseUrl = CRUD_SERVICE_URL
  if (!baseUrl || typeof baseUrl !== "string") {
    console.error(
      "CRUD_SERVICE_URL is not set. Set NEXT_PUBLIC_CRUD_SERVICE_URL or CRUD_SERVICE_URL in your environment."
    )
    return { status: 500, error: "CRUD service URL not configured" }
  }

  const res = await fetch(`${baseUrl}/${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : null,
  })

  // console.log("res.status:", res.status)
  if (res.status > 400) {
    // throw new Error("Bad Request")
    const json = { status: res.status, error: "Bad Request" }

    // const emojiForResponse = "❌"
    // dev_log(`${emojiForResponse} [${method}] QE/${path}`, "(response) ", json)
    return json
  }
  //
  else {
    const json = await res.json()

    // const emojiForResponse = json.error || json.Error ? "❌" : "✅"
    // dev_log(`${emojiForResponse} [${method}] CS/${path}`, "(response) ", json)
    return json
  }
}

export async function getLicense(licenseId: string) {
  const res = await fetchCrudService("GET", null, `public/license/${licenseId}`)
  const license: License = res.License
  return license
}

export async function getBusinessClassificationListBySearch(
  policyType: string,
  query: string
) {
  const res = await fetchCrudService(
    "POST",
    {
      policyType,
      query,
    },
    `public/industryCodes`
  )

  const businessClassificationList: {
    recommended: BusinessClassification[]
    rest: BusinessClassification[]
  } = res
  return businessClassificationList
}

export async function getPartnerWebpage(partnerWebpageId: string) {
  const res = await fetchCrudService(
    "GET",
    null,
    `public/partnerWebpage/${partnerWebpageId}`
  )
  return res.PartnerWebpage as IPartnerWebpage
}

export async function getConsultationLinkByBusinessId(
  savvyCalUrlPath: string,
  businessId: string
): Promise<ApiResponse<string | undefined>> {
  const res = (await fetchCrudService(
    "GET",
    null,
    `public/getConsultationLinkByBusinessId?` +
      `savvyCalUrlPath=${encodeURIComponent(savvyCalUrlPath)}` +
      `&businessId=${encodeURIComponent(businessId)}`
  )) as ApiResponse<string>
  return res
}
